import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSennheiserComponent } from './simple-icons-sennheiser.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSennheiserComponent ],
    exports:      [ SimpleIconsSennheiserComponent ],
    bootstrap:    []
})
export class SimpleIconsSennheiserModule {}
